module.exports = __webpack_public_path__ + "static/img/12areaA_01.93841e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/12areaA_01.png
// module id = 963
// module chunks = 1